module.exports = __webpack_public_path__ + "8a79171044606eeaf2e7af4e749a1228.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/hannukaih.png
// module id = 2397
// module chunks = 0